import React from 'react';
import { t } from 'ttag';
import './BuyNow.less';

const BuyNow = ({ banner }) => {
  const style = {
    backgroundColor: banner.button.color,
    border: banner.button.borderColor,
    color: banner.button.CtaTextColor,
  };
  const ctaText = banner.button.text;
  const renderBtnText = () => {
    switch (ctaText) {
      case 'Shop':
        return t`Shop`;
      case 'Shop now':
        return t`Shop now`;
      case 'Learn more':
        return t`Learn more`;
      case 'Explore':
        return t`Explore`;
      case 'Read more':
        return t`Read more`;
      case 'Get inspired':
        return t`Get inspired`;
      case 'Signup':
        return t`Signup`;
      default:
        return t`Shop now`;
    }
  };

  return (
    <a href={banner.button.link}>
      <button
        className="buy_button"
        type="button"
        style={style}
      >
        {renderBtnText(ctaText)}
      </button>
    </a>
  );
};

export default BuyNow;
